/**
 * 真人出镜直发「对镜说话 / 旁白」开关(1016 V1,用户拍板)。
 *
 * 契约:`speechModes` 是逐镜数组,直发单镜取长度 1(与 `voiceovers` 同长)。
 *   - `voiceover`(旁白,默认):口播是画外音,ai 会把画面里的说话动作改成手势示意、压嘴部动作。
 *   - `lip_sync`(对镜说话):ai 1013 起直发路认它 —— 台词先 TTS 成参考音频喂模型,人物口型对上口播。
 *     只在「文案出片」(orchestrate_real_person_bare)生效;「换我出镜」(R2V_SWAP)ai 恒按旁白,
 *     所以换我出镜不展示开关、也恒发 voiceover。所选模型不支持参考音频或参考音频生成失败时,
 *     ai 自动退回旁白(可见降级,不失败)。
 * 默认保持旁白 —— 不改变现有行为。
 */
export type RealPersonSpeechMode = "voiceover" | "lip_sync";

export const DEFAULT_REAL_PERSON_SPEECH_MODE: RealPersonSpeechMode = "voiceover";

export const REAL_PERSON_SPEECH_MODE_OPTIONS: ReadonlyArray<{
  value: RealPersonSpeechMode;
  label: string;
  hint: string;
}> = [
  { value: "lip_sync", label: "对镜说话", hint: "人物口型对上口播" },
  { value: "voiceover", label: "旁白", hint: "口播作画外音,人物不张嘴" },
];

/** 提交用的 speechModes:只有文案出片 + 显式选了对镜说话才发 lip_sync,其余一律旁白。 */
export function realPersonSpeechModes(
  mode: "text" | "swap",
  speechMode: RealPersonSpeechMode
): [RealPersonSpeechMode] {
  return [mode === "text" && speechMode === "lip_sync" ? "lip_sync" : "voiceover"];
}
